<div class="psp-container">

  <!-- ─── Page Header ─────────────────────────────────── -->
  <div class="psp-page-header">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="1.8" class="psp-page-icon" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <path d="M3 9h18"/>
      <path d="M9 21V9"/>
    </svg>
    <span class="psp-page-title">{{ currentPage?.pageName || 'Page' }}</span>
  </div>

  <!-- ─── Header Zone ───────────────────────────────────── -->
  <div class="psp-zone" *ngIf="headerSection">
    <div class="psp-zone-label">
      <span>Header</span>
    </div>

    <!-- Header above-the-fold features (Moving Text, Countdown Banner) -->
    <div class="psp-header-features">
      <div class="psp-feature-row" *ngIf="isMovingTextEnabled">
        <div class="psp-drag-spacer"></div>
        <div class="psp-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
            <path d="M3 6h18M3 12h12M3 18h9"/>
            <polyline points="17 15 21 12 17 9"/>
          </svg>
        </div>
        <span class="psp-name">Headline Banner</span>
        <button class="psp-action-btn psp-delete-btn" title="Remove Moving Text"
                (click)="removeHeaderFeature($event, 'movingText')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" width="13" height="13" aria-hidden="true">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6"/>
            <path d="M14 11v6"/>
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
          </svg>
        </button>
      </div>

      <div class="psp-feature-row" *ngIf="isCountdownBannerEnabled">
        <div class="psp-drag-spacer"></div>
        <div class="psp-icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <span class="psp-name">Countdown Banner</span>
        <button class="psp-action-btn psp-delete-btn" title="Remove Countdown Banner"
                (click)="removeHeaderFeature($event, 'countdownBanner')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" width="13" height="13" aria-hidden="true">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6"/>
            <path d="M14 11v6"/>
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
          </svg>
        </button>
      </div>

      <div class="psp-header-add" *ngIf="!hasAllHeaderFeatures">
        <button class="psp-header-add-btn" (click)="toggleHeaderAddMenu($event)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5" width="10" height="10" aria-hidden="true">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Add
        </button>
        <div class="psp-header-add-menu" *ngIf="showHeaderAddMenu">
          <div class="psp-add-menu-item" *ngIf="!isMovingTextEnabled"
               (click)="addHeaderFeature($event, 'movingText')">Headline Banner</div>
          <div class="psp-add-menu-item" *ngIf="!isCountdownBannerEnabled"
               (click)="addHeaderFeature($event, 'countdownBanner')">Countdown Banner</div>
        </div>
      </div>
    </div>

    <div class="psp-section-item">
      <div class="psp-section-row psp-fixed-section"
           [class.psp-active]="selectedSectionId === headerSection?.id"
           (click)="onSectionClick(headerSection)">
        <div class="psp-drag-spacer"></div>
        <div class="psp-icon-wrap">
          <ng-container [ngTemplateOutlet]="headerIcon"></ng-container>
        </div>
        <span class="psp-name" [title]="displayName(headerSection)">{{ displayName(headerSection) | titlecase }}</span>
        <!-- Expand button -->
        <!-- <button class="psp-expand-btn"
                [class.psp-expand-open]="isExpanded(headerSection?.id)"
                (click)="toggleExpand($event, headerSection?.id)"
                [title]="isExpanded(headerSection?.id) ? 'Collapse' : 'Expand'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5" width="12" height="12" aria-hidden="true">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button> -->
      </div>

      <!-- Block list (collapsible) -->
      <div class="psp-blocks-list" *ngIf="isExpanded(headerSection?.id)">
        <ng-container *ngFor="let block of getContentBlocks(headerSection)">
          <div class="psp-block-row"
               [class.psp-block-active]="selectedSectionId === headerSection?.id && selectedBlockId === block.id"
               (click)="onBlockClick($event, headerSection, block)">
            <div class="psp-block-icon">
              <ng-container [ngSwitch]="getBlockIcon(block.type)">
                <ng-container *ngSwitchCase="'text'"     [ngTemplateOutlet]="blockTextIcon"></ng-container>
                <ng-container *ngSwitchCase="'list'"     [ngTemplateOutlet]="blockListIcon"></ng-container>
                <ng-container *ngSwitchCase="'button'"   [ngTemplateOutlet]="blockButtonIcon"></ng-container>
                <ng-container *ngSwitchCase="'form'"     [ngTemplateOutlet]="blockFormIcon"></ng-container>
                <ng-container *ngSwitchCase="'location'" [ngTemplateOutlet]="blockLocationIcon"></ng-container>
                <ng-container *ngSwitchCase="'video'"    [ngTemplateOutlet]="blockVideoIcon"></ng-container>
                <ng-container *ngSwitchCase="'brand'"    [ngTemplateOutlet]="blockBrandIcon"></ng-container>
                <ng-container *ngSwitchCase="'social'"   [ngTemplateOutlet]="blockSocialIcon"></ng-container>
                <ng-container *ngSwitchCase="'toggle'"   [ngTemplateOutlet]="blockToggleIcon"></ng-container>
                <ng-container *ngSwitchDefault           [ngTemplateOutlet]="blockGridIcon"></ng-container>
              </ng-container>
            </div>
            <div class="psp-block-labels">
              <span class="psp-block-label">{{ block.label }}</span>
              <span class="psp-block-sublabel" *ngIf="block.subLabel">{{ block.subLabel }}</span>
            </div>
          </div>
        </ng-container>
        <div class="psp-no-blocks" *ngIf="getContentBlocks(headerSection).length === 0">
          <span>No editable blocks</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Template Zone ─────────────────────────────────── -->
  <div class="psp-zone psp-template-zone">
    <div class="psp-zone-label">
      <span>Template</span>
    </div>

    <!-- Empty state -->
    <div class="psp-empty-state" *ngIf="isEmpty">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="1.5" width="32" height="32" aria-hidden="true">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
      <p>No sections yet</p>
      <span>Add your first section</span>
      <button class="psp-add-section-btn" (click)="onAddSection('ABOVE', 0)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2.5" width="14" height="14" aria-hidden="true">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Add section
      </button>
    </div>

    <!-- Drop list for drag-and-drop -->
    <div cdkDropList
         (cdkDropListDropped)="onDrop($event)"
         class="psp-drop-list">

      <!-- Add above first section -->
      <div class="psp-add-between" *ngIf="!isEmpty" (click)="onAddSection('ABOVE', 0)">
        <span class="psp-add-line"></span>
        <span class="psp-add-plus">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5" width="10" height="10" aria-hidden="true">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </span>
        <span class="psp-add-line"></span>
      </div>

      <ng-container *ngFor="let section of templateSections; let i = index">
        <!-- Section item wrapper (NOT draggable itself so block-list stays outside CDK) -->
        <div class="psp-section-item" cdkDrag [cdkDragData]="section">

          <div class="psp-section-row psp-draggable"
               [class.psp-active]="selectedSectionId === section.id"
               (mouseenter)="hoveredSectionIndex = i"
               (mouseleave)="hoveredSectionIndex = -1"
               (click)="onSectionClick(section)">

            <!-- Drag handle -->
            <div class="psp-drag-handle" cdkDragHandle title="Drag to reorder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                   width="14" height="14" aria-hidden="true">
                <circle cx="9"  cy="6"  r="1.5"/>
                <circle cx="15" cy="6"  r="1.5"/>
                <circle cx="9"  cy="12" r="1.5"/>
                <circle cx="15" cy="12" r="1.5"/>
                <circle cx="9"  cy="18" r="1.5"/>
                <circle cx="15" cy="18" r="1.5"/>
              </svg>
            </div>

            <!-- Section icon -->
            <div class="psp-icon-wrap">
              <ng-container [ngSwitch]="getSectionIcon(section.sectionType)">
                <ng-container *ngSwitchCase="'banner'"      [ngTemplateOutlet]="bannerIcon"></ng-container>
                <ng-container *ngSwitchCase="'carousel'"    [ngTemplateOutlet]="carouselIcon"></ng-container>
                <ng-container *ngSwitchCase="'video'"       [ngTemplateOutlet]="videoIcon"></ng-container>
                <ng-container *ngSwitchCase="'text'"        [ngTemplateOutlet]="textIcon"></ng-container>
                <ng-container *ngSwitchCase="'grid'"        [ngTemplateOutlet]="gridIcon"></ng-container>
                <ng-container *ngSwitchCase="'contact'"     [ngTemplateOutlet]="contactIcon"></ng-container>
                <ng-container *ngSwitchCase="'testimonial'" [ngTemplateOutlet]="testimonialIcon"></ng-container>
                <ng-container *ngSwitchCase="'faq'"         [ngTemplateOutlet]="faqIcon"></ng-container>
                <ng-container *ngSwitchCase="'pricing'"     [ngTemplateOutlet]="pricingIcon"></ng-container>
                <ng-container *ngSwitchCase="'location'"    [ngTemplateOutlet]="locationIcon"></ng-container>
                <ng-container *ngSwitchCase="'team'"        [ngTemplateOutlet]="teamIcon"></ng-container>
                <ng-container *ngSwitchCase="'blog'"        [ngTemplateOutlet]="blogIcon"></ng-container>
                <ng-container *ngSwitchCase="'shop'"        [ngTemplateOutlet]="shopIcon"></ng-container>
                <ng-container *ngSwitchCase="'image'"       [ngTemplateOutlet]="imageIcon"></ng-container>
                <ng-container *ngSwitchCase="'logo'"        [ngTemplateOutlet]="logoIcon"></ng-container>
                <ng-container *ngSwitchDefault              [ngTemplateOutlet]="defaultIcon"></ng-container>
              </ng-container>
            </div>

            <!-- Section name -->
            <span class="psp-name" [title]="displayName(section)">
              {{ displayName(section) | titlecase }}
            </span>

            <!-- Hover actions -->
            <div class="psp-actions" [class.psp-actions-visible]="hoveredSectionIndex === i || selectedSectionId === section.id">
              <button class="psp-action-btn" title="Duplicate section"
                      (click)="onDuplicateSection($event, section, i)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" width="13" height="13" aria-hidden="true">
                  <rect x="9" y="9" width="13" height="13" rx="2"/>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                </svg>
              </button>
              <button class="psp-action-btn psp-delete-btn" title="Delete section"
                      (click)="onDeleteSection($event, i)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" width="13" height="13" aria-hidden="true">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                  <path d="M10 11v6"/>
                  <path d="M14 11v6"/>
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                </svg>
              </button>
            </div>

            <!-- Expand chevron -->
            <!-- <button class="psp-expand-btn"
                    [class.psp-expand-open]="isExpanded(section.id)"
                    (click)="toggleExpand($event, section.id)"
                    [title]="isExpanded(section.id) ? 'Collapse' : 'Expand'">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2.5" width="12" height="12" aria-hidden="true">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </button> -->

            <!-- CDK drag placeholder -->
            <div *cdkDragPlaceholder class="psp-drag-placeholder"></div>
          </div>

          <!-- Block list (collapsible, outside cdkDrag so it doesn't interfere) -->
          <div class="psp-blocks-list" *ngIf="isExpanded(section.id)">
            <ng-container *ngFor="let block of getContentBlocks(section)">
              <div class="psp-block-row"
                   [class.psp-block-active]="selectedSectionId === section.id && selectedBlockId === block.id"
                   (click)="onBlockClick($event, section, block)">
                <div class="psp-block-icon">
                  <ng-container [ngSwitch]="getBlockIcon(block.type)">
                    <ng-container *ngSwitchCase="'text'"     [ngTemplateOutlet]="blockTextIcon"></ng-container>
                    <ng-container *ngSwitchCase="'list'"     [ngTemplateOutlet]="blockListIcon"></ng-container>
                    <ng-container *ngSwitchCase="'button'"   [ngTemplateOutlet]="blockButtonIcon"></ng-container>
                    <ng-container *ngSwitchCase="'form'"     [ngTemplateOutlet]="blockFormIcon"></ng-container>
                    <ng-container *ngSwitchCase="'location'" [ngTemplateOutlet]="blockLocationIcon"></ng-container>
                    <ng-container *ngSwitchCase="'video'"    [ngTemplateOutlet]="blockVideoIcon"></ng-container>
                    <ng-container *ngSwitchCase="'brand'"    [ngTemplateOutlet]="blockBrandIcon"></ng-container>
                    <ng-container *ngSwitchCase="'social'"   [ngTemplateOutlet]="blockSocialIcon"></ng-container>
                    <ng-container *ngSwitchCase="'toggle'"   [ngTemplateOutlet]="blockToggleIcon"></ng-container>
                    <ng-container *ngSwitchDefault           [ngTemplateOutlet]="blockGridIcon"></ng-container>
                  </ng-container>
                </div>
                <div class="psp-block-labels">
                  <span class="psp-block-label">{{ block.label }}</span>
                  <span class="psp-block-sublabel" *ngIf="block.subLabel">{{ block.subLabel }}</span>
                </div>
              </div>
            </ng-container>
            <div class="psp-no-blocks" *ngIf="getContentBlocks(section).length === 0">
              <span>No editable blocks</span>
            </div>
          </div>
        </div>

        <!-- Add below section i -->
        <div class="psp-add-between" (click)="onAddSection('BELOW', i)">
          <span class="psp-add-line"></span>
          <span class="psp-add-plus">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.5" width="10" height="10" aria-hidden="true">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </span>
          <span class="psp-add-line"></span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- ─── Footer Zone ───────────────────────────────────── -->
  <div class="psp-zone psp-footer-zone" *ngIf="footerSection">
    <div class="psp-zone-label">
      <span>Footer</span>
    </div>

    <div class="psp-section-item">
      <div class="psp-section-row psp-fixed-section"
           [class.psp-active]="selectedSectionId === footerSection?.id"
           (click)="onSectionClick(footerSection)">
        <div class="psp-drag-spacer"></div>
        <div class="psp-icon-wrap">
          <ng-container [ngTemplateOutlet]="footerIcon"></ng-container>
        </div>
        <span class="psp-name" [title]="displayName(footerSection)">{{ displayName(footerSection) | titlecase }}</span>
        <!-- <button class="psp-expand-btn"
                [class.psp-expand-open]="isExpanded(footerSection?.id)"
                (click)="toggleExpand($event, footerSection?.id)"
                [title]="isExpanded(footerSection?.id) ? 'Collapse' : 'Expand'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5" width="12" height="12" aria-hidden="true">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button> -->
      </div>

      <!-- Block list (collapsible) -->
      <div class="psp-blocks-list" *ngIf="isExpanded(footerSection?.id)">
        <ng-container *ngFor="let block of getContentBlocks(footerSection)">
          <div class="psp-block-row"
               [class.psp-block-active]="selectedSectionId === footerSection?.id && selectedBlockId === block.id"
               (click)="onBlockClick($event, footerSection, block)">
            <div class="psp-block-icon">
              <ng-container [ngSwitch]="getBlockIcon(block.type)">
                <ng-container *ngSwitchCase="'text'"     [ngTemplateOutlet]="blockTextIcon"></ng-container>
                <ng-container *ngSwitchCase="'list'"     [ngTemplateOutlet]="blockListIcon"></ng-container>
                <ng-container *ngSwitchCase="'button'"   [ngTemplateOutlet]="blockButtonIcon"></ng-container>
                <ng-container *ngSwitchCase="'form'"     [ngTemplateOutlet]="blockFormIcon"></ng-container>
                <ng-container *ngSwitchCase="'location'" [ngTemplateOutlet]="blockLocationIcon"></ng-container>
                <ng-container *ngSwitchCase="'video'"    [ngTemplateOutlet]="blockVideoIcon"></ng-container>
                <ng-container *ngSwitchCase="'brand'"    [ngTemplateOutlet]="blockBrandIcon"></ng-container>
                <ng-container *ngSwitchCase="'social'"   [ngTemplateOutlet]="blockSocialIcon"></ng-container>
                <ng-container *ngSwitchCase="'toggle'"   [ngTemplateOutlet]="blockToggleIcon"></ng-container>
                <ng-container *ngSwitchDefault           [ngTemplateOutlet]="blockGridIcon"></ng-container>
              </ng-container>
            </div>
            <div class="psp-block-labels">
              <span class="psp-block-label">{{ block.label }}</span>
              <span class="psp-block-sublabel" *ngIf="block.subLabel">{{ block.subLabel }}</span>
            </div>
          </div>
        </ng-container>
        <div class="psp-no-blocks" *ngIf="getContentBlocks(footerSection).length === 0">
          <span>No editable blocks</span>
        </div>
      </div>
    </div>
  </div>

</div>


<!-- ─── SVG Icon Templates — sections ───────────────────── -->
<ng-template #headerIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M3 9h18"/>
  </svg>
</ng-template>

<ng-template #footerIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M3 15h18"/>
  </svg>
</ng-template>

<ng-template #bannerIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <polyline points="21 15 16 10 5 21"/>
  </svg>
</ng-template>

<ng-template #carouselIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="2" y="6" width="20" height="12" rx="2"/>
    <path d="M6 6V4"/>
    <path d="M18 6V4"/>
    <path d="M6 20v-2"/>
    <path d="M18 20v-2"/>
  </svg>
</ng-template>

<ng-template #videoIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <polygon points="23 7 16 12 23 17 23 7"/>
    <rect x="1" y="5" width="15" height="14" rx="2"/>
  </svg>
</ng-template>

<ng-template #textIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M4 6h16"/>
    <path d="M4 12h10"/>
    <path d="M4 18h14"/>
  </svg>
</ng-template>

<ng-template #gridIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7" rx="1"/>
    <rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/>
    <rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
</ng-template>

<ng-template #contactIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22 6 12 13 2 6"/>
  </svg>
</ng-template>

<ng-template #testimonialIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
</ng-template>

<ng-template #faqIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
</ng-template>

<ng-template #pricingIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <line x1="12" y1="1" x2="12" y2="23"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
</ng-template>

<ng-template #locationIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
</ng-template>

<ng-template #teamIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
</ng-template>

<ng-template #blogIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10 9 9 9 8 9"/>
  </svg>
</ng-template>

<ng-template #shopIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
    <line x1="3" y1="6" x2="21" y2="6"/>
    <path d="M16 10a4 4 0 0 1-8 0"/>
  </svg>
</ng-template>

<ng-template #imageIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <polyline points="21 15 16 10 5 21"/>
  </svg>
</ng-template>

<ng-template #logoIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 8v8"/>
    <path d="M8 12h8"/>
  </svg>
</ng-template>

<ng-template #defaultIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M3 9h18"/>
    <path d="M9 21V9"/>
  </svg>
</ng-template>


<!-- ─── SVG Icon Templates — blocks ─────────────────────── -->
<ng-template #blockTextIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <path d="M4 6h16M4 12h10M4 18h14"/>
  </svg>
</ng-template>

<ng-template #blockListIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <line x1="8" y1="6" x2="21" y2="6"/>
    <line x1="8" y1="12" x2="21" y2="12"/>
    <line x1="8" y1="18" x2="21" y2="18"/>
    <circle cx="3" cy="6" r="1.5" fill="currentColor" stroke="none"/>
    <circle cx="3" cy="12" r="1.5" fill="currentColor" stroke="none"/>
    <circle cx="3" cy="18" r="1.5" fill="currentColor" stroke="none"/>
  </svg>
</ng-template>

<ng-template #blockButtonIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <rect x="2" y="7" width="20" height="10" rx="5"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
</ng-template>

<ng-template #blockFormIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <rect x="2" y="4" width="20" height="6" rx="2"/>
    <rect x="2" y="14" width="20" height="6" rx="2"/>
  </svg>
</ng-template>

<ng-template #blockLocationIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
</ng-template>

<ng-template #blockVideoIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <polygon points="23 7 16 12 23 17 23 7"/>
    <rect x="1" y="5" width="15" height="14" rx="2"/>
  </svg>
</ng-template>

<ng-template #blockBrandIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <path d="M8 12h8M12 8v8"/>
  </svg>
</ng-template>

<ng-template #blockSocialIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <circle cx="18" cy="5" r="3"/>
    <circle cx="6"  cy="12" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
</ng-template>

<ng-template #blockToggleIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <rect x="1" y="7" width="22" height="10" rx="5"/>
    <circle cx="16" cy="12" r="3" fill="currentColor" stroke="none"/>
  </svg>
</ng-template>

<ng-template #blockGridIcon>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" width="11" height="11" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7" rx="1"/>
    <rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/>
    <rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
</ng-template>
